export default __webpack_public_path__ + "static/media/pins.d3de01b5.svg";